import React from "react";
import "./Common_Title_2.css";

const Common_Title_2 = ({ titleText, subText, simpleText }) => {
  return (
    <div className="Common_Title_2">
      <div className="botoom_title_div">
        <img src="/assets/images/title/left.png" className="left_img" />
        <p className="sub_text">{titleText}</p>
        <img src="/assets/images/title/right.png" className="right_img" />
      </div>
      {subText && <p className="title_text">{subText}</p>}
      {simpleText && <p className="simple_text">{simpleText}</p>}
    </div>
  );
};

export default Common_Title_2;
